













import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import * as c_Interface from '@/interface/components/home';

@Component
export default class Header extends Vue {
  // 추후에 경로 나오면 수정 필요
  public menuItems: Array<c_Interface.HeaderMenuBottom> = [
    { menu: 'Home', link: 'https://labsby.com', icon: 'el-icon-s-home' },
    { menu: 'Shop', link: 'https://cacheby.com', icon: 'el-icon-s-shop' },
    {
      menu: '사용 가이드',
      link: 'https://www.datasee.co.kr/64d593ed-eb21-449c-b5ab-91cc3f051aee',
      icon: 'el-icon-guide',
    },
    {
      menu: '공지사항',
      link: 'https://www.datasee.co.kr/3304cff5-2b34-4d2a-9809-78e7d2f136a2',
      icon: 'el-icon-info',
    },
    { menu: '문의하기', link: 'https://labsby.channel.io', icon: 'el-icon-question' },
  ];
}
